/*
 * @Author:
 * @LastEditTime: 2025-09-01 16:18:16
 * @Description:
 */
import VisualizationCockpitRouter from './routes'
import 'windi.css'

export default {
  // name version 必须为字面常量
  name: 'visualization-cockpit-tongre',
  title: '同热三维可视化驾驶舱',
  version: '0.1.3',
  description: '三维可视化驾驶舱',
  routes: VisualizationCockpitRouter, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: [
      'SectionApi',
      'FunctionInfoApi',
      'DataCategoryApi',
      'PreferenceSettingApi',
      'ModelSceneApi',
    ],
  },
  config: {},
  /**
   * init: async (store, router, config) {}
   * 异步初始化函数原型
   */
}
